import angular from 'angular';
import uiRouter from 'angular-ui-router';
import uiMenuComponent from './uiMenu.component';

let uiMenuModule = angular.module('uiMenu', [
	uiRouter,
]).component('uiMenu', uiMenuComponent).name;

export default uiMenuModule;



// WEBPACK FOOTER //
// ./client/app/common/uiMenu/uiMenu.js